function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownArrowSvg = function SvgDownArrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 119 119"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "currentColor",
      fillOpacity: 1
    },
    d: "M119 59.5c0 32.86-26.64 59.5-59.5 59.5S0 92.36 0 59.5 26.64 0 59.5 0 119 26.64 119 59.5Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "m83.266 45.414-22.04 22.04-22.09-22.09c-6.421-6.426-16.35 3.581-9.91 10.019 9.016 9.015 18.028 18.031 27.044 27.047 2.726 2.722 7.265 2.648 9.968-.055l27.043-27.047c6.426-6.422-3.582-16.351-10.015-9.914Zm0 0"
  }));
};
export default SvgDownArrowSvg;